







































import Vue, { PropType } from 'vue';
import SearchBox from '@/components/util/SearchBox.vue';
import { SkillType, Language, Tool, Others, SkillMastar } from '@/api/dto/Skill';

export default Vue.extend({
  name: 'AddSkillModal',
  components: {
    SearchBox,
  },
  props: {
    getQueries: [String, Array] as PropType<string | string[]>,
    showType: {
      type: String as PropType<SkillType | '0'>,
      default: '0',
    },
    selectNum: {
      type: Number,
      default: 0,
    },
    unselectedClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      setKeyword: '',
      selected: '' as string | string[],
      skills: [] as string[],
    }
  },
  created() {
    this.selected = this.getQueries;
    var localSkill = JSON.parse(localStorage.getItem('skill') as string) as SkillMastar[];
    switch(this.showType) {
      case Language: // 言語+その他
        this.skills = localSkill.filter(v => v.type == Language || v.type == Others).map(v => v.skillName);
        break;
      case Tool: // 技術+その他
        this.skills = localSkill.filter(v => v.type == Tool || v.type == Others).map(v => v.skillName);
        break;
      default: // すべて
        this.skills = localSkill.map(v => v.skillName);
    }
  },
  computed: {
    filteredSkills(): string[] {
      if(this.setKeyword) { // キーワード検索
        var reg = new RegExp(this.setKeyword, "i");

        // NOTE: 選択中のスキル・タグは検索結果に表示しない
        const selected = typeof this.selected === "string" ? [this.selected] : this.selected;
        return this.skills.filter(value => !selected.includes(value)).filter(v => v.match(reg));
      } else {
        return this.skills;
      }
    },
  },
  methods: {
    /** 選択数のチェック */
    chackSelectNum() {
      var result = false;
      switch(this.selectNum) {
        case 0: // 無制限の場合
        case 1: // 単一の場合
          result = true;
          break;
        default: // 制限ありの場合
          if(this.selected.length > this.selectNum) {
            this.$emit('alert', this.selectNum+'つ以上登録できません');
          } else {
            result = true;
          }
      }
      if(result) {
        this.$emit('queries', this.selected);
        this.$emit('close');
      }
    },
    /** モーダルを閉じる */
    close() {
      if(this.unselectedClose) { // 未選択時にモーダル閉じる可
        this.chackSelectNum();
      } else { // 未選択時にモーダル閉じる不可
        if(this.selected.length) {
          this.chackSelectNum();
        } else {
          this.$emit('alert', '選択してください');
        }
      }
    },
    /** 選択解除-選択数が単一 */
    cancelItem() {
      this.selected = '';
    },
    /** 選択解除-選択数が複数 */
    cancelItems(index: number) {
      (this.selected as string[]).splice(index, 1);
    },
    /**  ラジオボタンの場合の選択イベント */
    selectItem(item: string) {
      this.selected = item;
      this.close();
    },
  }
})
